import { h, FunctionComponent } from 'preact';

type LoaderProps = {
  wrapperClassName?: string;
  currentOrigin: string;
};

export const Loader: FunctionComponent<LoaderProps> = ({ wrapperClassName, currentOrigin }) => (
  <div className={`${wrapperClassName || ''}`}>
    <img
      alt="Loading"
      width={100}
      height={150}
      src={`${currentOrigin}/cascoon/schedule_loader.svg`}
    />
  </div>
);
